import { render } from "./Gospel.vue?vue&type=template&id=9d468866"
import script from "./Gospel.vue?vue&type=script&lang=js"
export * from "./Gospel.vue?vue&type=script&lang=js"

import "./Gospel.vue?vue&type=style&index=0&id=9d468866&lang=css"

import exportComponent from "/Users/paul/Documents/websites/shape/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__